export default __webpack_public_path__ + "0b5ad459edddb21817df5c9bb74509f4.svg";